// App.js
import React from 'react';
import './App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faTelegramPlane, faMastodon, faSteam, faUnsplash, faApple, faSpotify } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPen, faMusic } from '@fortawesome/free-solid-svg-icons';
import MusicNote from './MusicNote';
import { ReactComponent as GrafanaLogo } from './icons/grafana.svg';

// 音符图标组件
function NoteIcon() {
    return <FontAwesomeIcon icon={faMusic} className="note-icon floating" />;
}

function App() {
    // 创建状态来存储当前的颜色模式
    const trackingUrl = `https://api.bdim.moe/expired?date=${Date.now()}&origin=${encodeURIComponent(window.location.hostname)}&path=${encodeURIComponent(window.location.pathname)}&search=${encodeURIComponent(window.location.search)}`;

    return (
        <div className="App">
            <img src={trackingUrl} width="0" height="0" style={{display:'none'}} alt="" />
            <header className="App-header">
                <MusicNote className="music-note" />
                <h1 className="App-title">Bdim - 减三和弦 <NoteIcon /></h1>
                <div className="App-links">
                    <a href="https://github.com/bdim404" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faGithub}/>
                    </a>
                    <a href="https://t.me/bdim404" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faTelegramPlane}/>
                    </a>
                    <a href="mailto:work@bdim.moe" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faEnvelope}/>
                    </a>
                    <a href="https://blog.bdim.moe" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faPen}/>
                    </a>
                    <a href="https://mastodon.social/@Bdim404" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faMastodon}/>
                    </a>
                    <a href="https://steamcommunity.com/id/bdim/" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faSteam}/>
                    </a>
                    <a href="https://unsplash.com/@bdim404" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faUnsplash}/>
                    </a>
                    <a href="https://grafana.bdim.moe" target="_blank" rel="noopener noreferrer">
                        <GrafanaLogo className="icon" />
                    </a>
                    <a href="https://music.apple.com/us/playlist/favorite-songs/pl.u-V5U3loe9by" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faApple}/>
                    </a>
                    <a href="https://open.spotify.com/user/31pcxjqgpujwzcrqi7ibm6vb6bpu?si=32b385e2ba9d4477" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faSpotify}/>
                    </a>
                </div>
                <p className="custom-style">中文 & English</p>
                <p className="custom-style">青年二胡演奏家 & 全栈开发工程师</p>
                <p className="custom-style">人工智能音乐 Music AI learner</p>
                <p className="custom-style">摄影 Photography Enthusiast</p>
                <p className="custom-style">Graduate in Music Performance</p>
                <p className="custom-style">
                <a href="https://infidive.com" target="_blank" rel="noopener noreferrer">Infidive（潜入梦）</a>
                {" "}Full-stack Development Engineer
                </p>
                <p className="custom-style">Erhu-Performer & Computer-enthusiast</p>
            </header>
        </div>
    );
}

export default App;
